import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider, UserInfoContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { CRMIntegrationList } from '../Components/Organisms/CRMConfiguration/List/CRMIntegrationList'

@Route(RouteID.CRM_INTEGRATION)
export class CRMIntegration extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CRM_INTEGRATION}>
                <UserInfoContextProvider>
                    <LanguageContextProvider>
                        <CRMIntegrationList />
                    </LanguageContextProvider>
                </UserInfoContextProvider>
            </RouteGuard>
        )
    }
}
